// react components
import React, {
    useState,
} from 'react'
import {
    useSelector,
} from 'react-redux'

// pages
import {
    Button825,
    Popover825,
} from 'pages'

// data
import {
    defaultReduxState,
} from 'data'

// props
type AddButton825Props = {
    inModal?: boolean
    onShowModalForm: (subContentTypeId?: number, isImage?: boolean) => void
    size?: any
    subContentTypes?: {
        id?: number
        name?: string
        isImage?: boolean
    }[]
}

// main
export const AddButton825: React.FC<AddButton825Props> = React.memo(({
    inModal,
    onShowModalForm,
    size,
    subContentTypes,
}) => {

    const reduxText = useSelector((state: defaultReduxState) => state.reduxText.data)

    const [showActionPopover, setShowActionPopover] = useState(false)

    if (subContentTypes?.length! > 0) {

        const buttons: any = []
        subContentTypes?.forEach((val) => {
            buttons.push({
                handler: () => {
                    onShowModalForm(val.id, val.isImage)
                    setShowActionPopover(false)
                },
                text: val.name,
            })
        })

        return (
            <Popover825
                buttons={buttons}
                edit={false}
                extraZIndex={inModal}
                isButtonText='Ajouter'
                isOpen={showActionPopover}
                setIsOpen={setShowActionPopover}
                size={size || 'small'}
            />
        )

    }

    return (
        <Button825
            edit={false}
            onClick={() => onShowModalForm()}
            padding='0 20px 0 0'
            size={size || 'small'}
            text='Ajouter'
        />
    )
})
